/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../higherOrderComponents/requests';
import { isValidToken } from '../../../../lib/isValidToken';

export default connectRequests((state, props) => {
  const token = state.token;
  return {
    login: {
      url: '/login',
      method: 'POST'
    },
    instanceInfo: {
      url: `/instances/${props.match.params.aliasKey}/status/preview?locale=en`,
      onLoad: true
    },
    subscriber: {
      url: `/subscribers?token=${token}&normalize=true`,
      onLoad: isValidToken(token),
    },
    patchSubscriber: {
      method: 'PATCH',
      url: `/subscribers?token=${token}`
    },
    postSubscription: {
      method: 'POST',
      url: `/subscribers/subscriptions?token=${token}`
    },
    addNumber: {
      method: 'POST',
      url: '/addNumber?token=${token}'
    },
    verifyEmailUser: {
      method: 'POST',
      url: '/verifyEmailUser'
    },
    verifyUser: {
      method: 'POST',
      url: '/verifyUser?token=${token}'
    },
    emailVerify: {
      method: 'GET',
      url: `/setEmailUser?token=${token}`
    }
  };
});

// export default connectRequests(mapStateToRequests);
